import { ContentLimiter } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { Gewerbeberechtigung, NationaleMarke, Patent } from 'components/profiles';
import React from 'react';
import { UnternehmenPlusDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

interface IntellectualPropertyProps 
{
  unternehmen: UnternehmenPlusDto;
}

const ImmaterialGüter: React.FC<IntellectualPropertyProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');
  
  return (
    <>

      {/* Nationale Marken */}
      {unternehmen.nationaleMarken && unternehmen.nationaleMarken.length > 0 && (
        <ContentRow id="marken" title={t('profiles:unternehmen.marken.label')}>

          <ul className="no-list-style">
            <ContentLimiter>
              {unternehmen.nationaleMarken.map((marke) => (
                <NationaleMarke key={marke.id} id={`dlt-marke-${marke.id}`} data={marke} />
              ))}
            </ContentLimiter>
          </ul>

        </ContentRow>
      )}

      {/* Gewerbeberechtigungen */}
      {unternehmen.eigeneGewerbe && (unternehmen.eigeneGewerbe.length > 0 || unternehmen.nutzendeGewerbe.length > 0) && (
        <ContentRow id="gewerbeberechtigungen" title={t('profiles:gewerbe.label')}>
          
          <ul className="no-list-style">
            <ContentLimiter>
              {[...unternehmen.eigeneGewerbe, ...unternehmen.nutzendeGewerbe].map((gewerbe) => (
                <Gewerbeberechtigung key={gewerbe.gisaNr} gewerbe={gewerbe} />
              ))}
            </ContentLimiter>
          </ul>
          
        </ContentRow>
      )}

      {/* Patente */}
      {unternehmen.patente && unternehmen.patente.length > 0 && (
        <ContentRow id="patente" title={t('profiles:unternehmen.patente.label')}>
          
          <ul className="no-list-style">
            <ContentLimiter>
              {unternehmen.patente.map((patent) => (
                <Patent key={patent.id} patent={patent} />
              ))}
            </ContentLimiter>
          </ul>
          
        </ContentRow>
      )}

    </>
  );
};

export default ImmaterialGüter;
